export default __webpack_public_path__ + "static/media/slide2.c70d72e2.png";